import React, {useState} from 'react';
import {Modal, message} from 'antd';
import Form from '../data_entry/form/Form';
import PasswordFields from './PasswordFields';
import api from '../../services/api';
import ENDPOINTS from '../../constants/endpoints';
import {formatPath} from '../../constants/PathRoutes';

export default function ChangePasswordModal({open, onClose, staffId, staffName}) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            await api.patch(formatPath(ENDPOINTS.STAFF_DETAIL, {id: staffId}), {
                password: values.password
            });

            message.success('Senha alterada com sucesso');
            form.resetFields();
            onClose();
        } catch (error) {
            if (error.response?.data?.detail) {
                message.error(error.response.data.detail);
            } else if (!error.errorFields) {
                message.error('Erro ao alterar senha');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title={`Alterar Senha - ${staffName}`}
            open={open}
            onOk={handleSubmit}
            onCancel={handleCancel}
            confirmLoading={loading}
            okText="Salvar"
            cancelText="Cancelar"
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <PasswordFields form={form} required={true} />
            </Form>
        </Modal>
    );
}